import { useQuery } from '@tanstack/react-query';
import { Notification_ReadState } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { listNotificationsQuery } from '~/shared/api/listNotifications.queries';

export function useHasUnreadNotifications() {
  const { data, isLoading } = useQuery(
    listNotificationsQuery(Notification_ReadState.UNREAD),
  );

  const hasUnread = (data?.notifications.length ?? 0) > 0;

  return {
    hasUnreadNotifications: hasUnread,
    isLoading,
  };
}
